(function(){
  'use strict';

  function init(){
    var root=document.querySelector('[data-arshe-scent-finder]');
    if(!root || root.dataset.ready==='1') return;
    root.dataset.ready='1';

    var fab=root.querySelector('[data-sf-open]');
    var panel=root.querySelector('.arshe-scent-finder__panel');
    var panelBody=root.querySelector('.arshe-scent-finder__body');
    var backdrop=root.querySelector('.arshe-scent-finder__backdrop');
    var screens={};
    root.querySelectorAll('[data-sf-screen]').forEach(function(el){
      screens[el.getAttribute('data-sf-screen')]=el;
    });

    var qHost=root.querySelector('[data-sf-question-host]');
    var progress=root.querySelector('[data-sf-progress]');
    var progressBar=root.querySelector('[data-sf-progress-bar]');
    var result=root.querySelector('[data-sf-result]');
    var alternates=root.querySelector('[data-sf-alternates]');
    var lastFocused=null;
    var lockState=null;
    var current=0;
    var answers=[];
    var questions=[
      {text:'What do you want your fragrance to do when you enter a room?',options:[
        ['fresh','Stay effortless.','Clean, crisp and naturally put-together.'],
        ['noticeable','Be noticed.','Present, distinctive and impossible to miss.'],
        ['memorable','Leave an impression.','The kind of scent people remember.'],
        ['entrance','Own the room.','A stronger presence with serious character.']
      ]},
      {text:'Where is your scent doing its best work?',options:[
        ['everyday','Everyday','Easy from morning through the day.'],
        ['work','Work & occasions','Polished when presence matters.'],
        ['date','First date','Closer, warmer and more memorable.'],
        ['party','After dark','Built for the night to begin.']
      ]},
      {text:'Which scent world pulls you in?',options:[
        ['aquatic','Fresh & aquatic','Airy, cool, clean and modern.'],
        ['woody','Woody & spicy','Warm woods with depth and character.'],
        ['gourmand','Sweet & addictive','Smooth, rich and hard to forget.'],
        ['floral','Floral & elegant','Expressive, refined and beautifully soft.']
      ]},
      {text:'How should your signature sit on skin?',options:[
        ['soft','Stay close.','Intimate and understated.'],
        ['balanced','Be present.','Noticeable without taking over.'],
        ['strong','Make an impression.','Distinct with real presence.'],
        ['bold','Command attention.','For when blending in is not the plan.']
      ]},
      {text:'Choose the version of yourself you are stepping into.',options:[
        ['clean','Clean & composed','Refined, effortless and clear.'],
        ['confident','Confident & bold','Self-assured with character.'],
        ['seductive','Seductive & unforgettable','Magnetic, warm and memorable.'],
        ['luxury','Dark & luxurious','Deep, expressive and commanding.']
      ]}
    ];

    var answerWeights={
      fresh:['fresh','clean','aquatic','citrus','cool'],
      noticeable:['noticeable','confident','vibrant','modern'],
      memorable:['memorable','impression','romantic','addictive','strong'],
      entrance:['strong','bold','luxurious','confident','noticeable'],
      everyday:['daytime','everyday','clean','moderate'],
      work:['office','formal','sophisticated','moderate','clean','elegant'],
      date:['date','first-date','romantic','sensual','sweet','evening'],
      party:['strong','bold','evening','party','noticeable','after-dark'],
      aquatic:['fresh','aquatic','citrus','cool'],
      woody:['woody','spicy','smoky'],
      gourmand:['sweet','gourmand','vanilla','caramel','amber','addictive'],
      floral:['floral','elegant','romantic','soft','sensual'],
      soft:['soft','moderate','romantic'],
      balanced:['moderate','balanced','clean'],
      strong:['strong','noticeable','bold'],
      bold:['bold','strong','luxurious','confident','impression'],
      clean:['clean','fresh','elegant','sophisticated'],
      confident:['confident','woody','spicy','noticeable','bold'],
      seductive:['sweet','amber','musk','sensual','evening','memorable'],
      luxury:['oud','amber','woody','luxurious','dark','bold']
    };

    var profiles,products;
    try{products=JSON.parse(root.querySelector('[data-sf-products]').textContent||'[]');}catch(e){products=[];}
    try{profiles=JSON.parse(root.querySelector('[data-sf-profiles]').textContent||'{}');}catch(e){profiles={};}

    var profileOrder=['hawas-ice','hawas','caramel-oud','oud-wood','aqua-di-gio','cool-water','flora','jasmine','juicy-bloom','90s-love','19-11'];

    var inferredRules=[
      {keys:['hawas ice','hawas-ice','icy'],attrs:['fresh','aquatic','cool','clean','summer']},
      {keys:['hawas'],attrs:['fresh','aquatic','fruity','clean','confident','noticeable']},
      {keys:['aqua di gio','aqua-di-gio','acqua di gio'],attrs:['fresh','aquatic','citrus','clean','summer','everyday']},
      {keys:['cool water','cool-water'],attrs:['fresh','aquatic','clean','cool','summer']},
      {keys:['zara gardenia','zara-gardenia','gardenia'],attrs:['floral','elegant','romantic','soft','date']},
      {keys:['jasmine'],attrs:['floral','elegant','romantic','soft','sensual','date']},
      {keys:['cr7','ar7'],attrs:['fresh','woody','spicy','confident','clean','noticeable']},
      {keys:['mont blanc','mont-blanc','montblanc'],attrs:['fresh','woody','clean','elegant','sophisticated']},
      {keys:['escada magnetism','escada-magnetism','magnetism'],attrs:['sweet','fruity','floral','romantic','sensual','evening']},
      {keys:['eden juicy apple','eden-juicy-apple','juicy apple'],attrs:['fruity','fresh','sweet','playful','summer','date']},
      {keys:['oud'],attrs:['oud','woody','dark','luxurious','bold','evening']},
      {keys:['caramel'],attrs:['sweet','gourmand','caramel','vanilla','amber','warm','addictive']},
      {keys:['floral','flora','jasmine','rose','gardenia'],attrs:['floral','elegant','romantic','soft']},
      {keys:['aqua','ocean','marine','blue'],attrs:['fresh','aquatic','clean','cool','summer']},
      {keys:['woody','wood','spice','spicy'],attrs:['woody','spicy','warm','confident']},
      {keys:['vanilla','sweet','caramel','amber'],attrs:['sweet','gourmand','warm','addictive']},
      {keys:['fresh','citrus','mint'],attrs:['fresh','clean','aquatic','daytime']},
    ];

    function productTags(p){
      return Array.isArray(p.tags)?p.tags.map(function(t){return String(t).toLowerCase();}):[];
    }

    function buildAttributes(p){
      var manual=profiles[p.handle]||[];
      var hay=[p.handle,p.title,p.type,p.description].concat(productTags(p)).concat(noteList(p.notes&&p.notes.top),noteList(p.notes&&p.notes.heart),noteList(p.notes&&p.notes.base)).join(' ').toLowerCase();
      var attrs=manual.slice();
      inferredRules.forEach(function(rule){
        if(rule.keys.some(function(k){return hay.indexOf(k)!==-1;})) attrs=attrs.concat(rule.attrs);
      });
      productTags(p).forEach(function(tag){
        var t=tag.replace(/[^a-z0-9-]+/g,'-');
        if(t.indexOf('moment-')===0) attrs.push(t.replace('moment-',''));
        if(t.indexOf('mood-')===0) attrs.push(t.replace('mood-',''));
        if(t.indexOf('profile-')===0) attrs.push(t.replace('profile-',''));
        if(/new[- ]?arrival|new-arrival|new_arrival|new/.test(tag)) attrs.push('new-arrival');
      });
      return attrs.filter(function(v,i,a){return a.indexOf(v)===i;});
    }

    products.forEach(function(p){ if(!profiles[p.handle]) profiles[p.handle]=buildAttributes(p); });

    function esc(s){
      return String(s==null?'':s).replace(/[&<>"']/g,function(c){
        return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
      });
    }

    function cleanProductTitle(title){
      var value=String(title||'').trim();
      return value.replace(/^ARSH[ÉE]\s+/i,'').trim() || value;
    }

    function cleanProductType(type){
      return String(type||'').replace(/\s+/g,' ').trim();
    }

    function cleanProductDescription(description,title,type){
      var value=String(description||'').replace(/\s+/g,' ').trim();
      if(!value)return '';
      var safeTitle=String(title||'').trim();
      var safeType=String(type||'').trim();
      function escReg(v){return v.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');}
      value=value.replace(/^ARSHE?\s+/i,'');
      if(safeTitle)value=value.replace(new RegExp('^'+escReg(safeTitle)+'\\s*','i'),'');
      if(safeType)value=value.replace(new RegExp('^'+escReg(safeType)+'\\s*','i'),'');
      value=value.replace(/([.!?])(?=[A-Z])/g,'$1 ');
      value=value.replace(/\s{2,}/g,' ').trim();
      return value.length>210 ? value.slice(0,207).replace(/\s+\S*$/,'')+'…' : value;
    }

    function scrollContentToTop(){
      if(panelBody)panelBody.scrollTop=0;
    }

    function show(name){
      Object.keys(screens).forEach(function(k){
        screens[k].classList.toggle('is-active',k===name);
      });
    }

    function noteList(raw){
      if(!raw) return [];
      if(Array.isArray(raw)) return raw.map(function(x){return String(x).trim();}).filter(Boolean);
      return String(raw).replace(/^\s*[\[\{]+|[\]\}]+\s*$/g,'')
        .replace(/["']/g,'').replace(/;/g,',').split(',')
        .map(function(x){return x.trim();}).filter(Boolean);
    }

    function renderQuestion(){
      var q=questions[current];
      progress.textContent=String(current+1).padStart(2,'0')+' / 05';
      progressBar.style.width=((current+1)/questions.length*100)+'%';

      qHost.innerHTML=
        '<div class="arshe-scent-finder__question-number">QUESTION '+String(current+1).padStart(2,'0')+'</div>'+
        '<h3 class="arshe-scent-finder__question">'+esc(q.text)+'</h3>'+
        '<div class="arshe-scent-finder__options">'+
        q.options.map(function(o){
          return '<button class="arshe-scent-finder__option'+(answers[current]===o[0]?' is-selected':'')+'" type="button" data-answer="'+esc(o[0])+'">'+
            '<span class="arshe-scent-finder__option-main">'+esc(o[1])+'</span>'+
            '<span class="arshe-scent-finder__option-sub">'+esc(o[2])+'</span>'+
          '</button>';
        }).join('')+'</div>';

      qHost.querySelectorAll('[data-answer]').forEach(function(btn){
        btn.addEventListener('click',function(){
          answers[current]=this.getAttribute('data-answer');
          this.classList.add('is-selected');
          window.setTimeout(function(){
            if(current<questions.length-1){current++;renderQuestion();}
            else{renderResult();}
          },150);
        });
      });
      show('quiz');
      window.requestAnimationFrame(scrollContentToTop);
    }

    function scoreProduct(p){
      var attrs=profiles[p.handle]||buildAttributes(p);
      var score=0;
      answers.forEach(function(a){
        (answerWeights[a]||[]).forEach(function(attr){
          if(attrs.indexOf(attr)!==-1) score+=1;
        });
      });
      var tags=productTags(p);
      if(p.newArrival===true || tags.some(function(t){return /new[- _]?arrival|new-arrival|new_arrival/.test(t);})) score+=2;
      return score;
    }

    function percent(score,max){
      if(max<=0) return 50;
      return Math.max(50,Math.min(98,Math.round(60+(score/max)*38)));
    }

    function whyMatch(p){
      var chosen=answers.map(function(a,i){
        var q=questions[i];
        var item=q.options.find(function(o){return o[0]===a;});
        return item ? item[1] : '';
      }).filter(Boolean);

      var attrs=profiles[p.handle]||[];
      var lines=[];
      var preferenceMap=[
        {keys:['fresh','aquatic','clean','citrus'],text:'A fresh, clean direction aligns with what you chose.'},
        {keys:['sweet','gourmand','vanilla','caramel'],text:'Its sweeter character fits the mood you gravitated toward.'},
        {keys:['woody','spicy','oud'],text:'Its woody/spiced character matches your stronger, confident choices.'},
        {keys:['floral','elegant'],text:'Its elegant character follows the refined direction you selected.'},
        {keys:['strong','bold','noticeable'],text:'Its presence suits the level of attention you asked for.'},
        {keys:['soft','moderate'],text:'Its more measured presence fits the way you want fragrance to sit.'},
        {keys:['amber','musk','seductive'],text:'Its warmer, more magnetic character suits your chosen energy.'}
      ];
      preferenceMap.forEach(function(item){
        if(lines.length<3 && item.keys.some(function(k){return attrs.indexOf(k)!==-1;})) lines.push(item.text);
      });
      if(!lines.length && chosen.length) lines.push('Its character aligns closely with the choices you made.');
      return lines.slice(0,3);
    }

    function renderNotes(p){
      var n=p.notes||{};
      var top=noteList(n.top),heart=noteList(n.heart),base=noteList(n.base);
      if(!top.length&&!heart.length&&!base.length) return '';
      function group(label,list,image){
        if(!list.length) return '';
        return '<div class="arshe-scent-finder__note-group">'+
          '<span class="arshe-scent-finder__note-layer">'+label+'</span>'+
          '<div class="arshe-scent-finder__note-chips">'+
          list.map(function(note){
            return '<span class="arshe-scent-finder__note-chip">'+
              (image?'<img src="'+esc(image)+'" alt="" loading="lazy">':'')+
              '<span>'+esc(note)+'</span></span>';
          }).join('')+'</div></div>';
      }
      return '<div class="arshe-scent-finder__notes"><p class="arshe-scent-finder__notes-title">FRAGRANCE NOTES</p>'+
        group('TOP',top,n.topImage)+group('HEART',heart,n.heartImage)+group('BASE',base,n.baseImage)+
      '</div>';
    }

    function renderResult(){
      var scored=products.map(function(p){
        return {p:p,score:scoreProduct(p)};
      }).filter(function(x){return profiles[x.p.handle];});

      scored.sort(function(a,b){
        if(b.score!==a.score)return b.score-a.score;
        var ai=profileOrder.indexOf(a.p.handle),bi=profileOrder.indexOf(b.p.handle);
        if(ai===-1)ai=9999;if(bi===-1)bi=9999;
        return ai-bi;
      });

      if(!scored.length){
        result.innerHTML='<div class="arshe-scent-finder__result-note"><strong>YOUR SCENT MATCH</strong><br>We could not load the fragrance catalogue right now. Please explore the ARSHÉ collection.</div>';
        alternates.innerHTML='';
        show('result');
        window.requestAnimationFrame(scrollContentToTop);
        return;
      }

      var top=scored[0],second=scored[1],third=scored[2];
      var maxScore=answers.reduce(function(total,a){return total+(answerWeights[a]||[]).length;},0);
      var topPct=percent(top.score,maxScore);
      var displayTitle=cleanProductTitle(top.p.title);
      var productType=cleanProductType(top.p.type);
      var desc=cleanProductDescription(top.p.description,displayTitle,productType);
      var why=whyMatch(top.p);
      var currentPath=window.location.pathname.replace(/\/$/,'');
      var topPath=String(top.p.url||'').split('?')[0].replace(/\/$/,'');
      var foundNote=currentPath && currentPath===topPath ? 'YOU’VE FOUND YOUR MATCH.' : 'MADE FOR YOUR KIND OF PRESENCE.';
      var discoveryUrl=root.dataset.discoveryUrl || '/products/discovery-set';

      result.innerHTML=
        '<div class="arshe-scent-finder__result-reveal">'+
          '<div class="arshe-scent-finder__match-media">'+
            (top.p.image?'<img src="'+esc(top.p.image)+'" alt="'+esc(top.p.title)+'" loading="lazy">':'')+
          '</div>'+
          '<div class="arshe-scent-finder__match-copy">'+
            '<h3 class="arshe-scent-finder__match-name">'+esc(displayTitle)+'</h3>'+
            ((top.p.newArrival===true || (top.p.tags||[]).some(function(t){return /new[- _]?arrival|new-arrival|new_arrival/.test(String(t).toLowerCase());}))?'<span class="arshe-scent-finder__new-badge">NEW ARRIVAL</span>':'')+
            (productType?'<p class="arshe-scent-finder__match-type">'+esc(productType)+'</p>':'')+
            '<div class="arshe-scent-finder__match-score"><span data-match-number>0</span>% MATCH</div>'+
            (desc?'<p class="arshe-scent-finder__match-desc">'+esc(desc)+'</p>':'')+
          '</div>'+
        '</div>'+
        '<p class="arshe-scent-finder__presence-note">'+esc(foundNote)+'</p>'+
        '<div class="arshe-scent-finder__why">'+
          '<p class="arshe-scent-finder__why-title">WHY IT MATCHES YOU</p>'+
          '<ul>'+why.map(function(line){return '<li><span aria-hidden="true">✓</span>'+esc(line)+'</li>';}).join('')+'</ul>'+
        '</div>'+
        renderNotes(top.p)+
        '<div class="arshe-scent-finder__result-actions">'+
          '<a class="arshe-scent-finder__primary" href="'+esc(top.p.url)+'">DISCOVER THIS FRAGRANCE <span aria-hidden="true">→</span></a>'+
          '<a class="arshe-scent-finder__secondary" href="'+esc(discoveryUrl)+'">EXPLORE THE DISCOVERY SET <span aria-hidden="true">→</span></a>'+
        '</div>';

      var number=result.querySelector('[data-match-number]');
      var start=0,end=topPct,duration=600,startTime=null;
      function animateMatch(ts){
        if(startTime===null)startTime=ts;
        var p=Math.min(1,(ts-startTime)/duration);
        var eased=1-Math.pow(1-p,3);
        number.textContent=Math.round(start+(end-start)*eased);
        if(p<1)requestAnimationFrame(animateMatch);
      }
      if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        number.textContent=topPct;
      }else{
        requestAnimationFrame(animateMatch);
      }

      var alt=[second,third].filter(Boolean);
      var clearWinner=!second || (top.score-second.score>=2);
      alternates.innerHTML=
        (alt.length?
          '<div class="arshe-scent-finder__alternates-head"><p>ALSO WORTH DISCOVERING</p></div>'+
          '<div class="arshe-scent-finder__alt-list">'+
          alt.map(function(x){
            return '<a class="arshe-scent-finder__alt" href="'+esc(x.p.url)+'">'+
              '<span class="arshe-scent-finder__alt-media">'+(x.p.image?'<img src="'+esc(x.p.image)+'" alt="" loading="lazy">':'')+'</span>'+
              '<span class="arshe-scent-finder__alt-copy"><span class="arshe-scent-finder__alt-name">'+esc(x.p.title)+'</span><span class="arshe-scent-finder__alt-price">'+esc(x.p.price)+'</span></span>'+
              '<span class="arshe-scent-finder__alt-score">'+percent(x.score,maxScore)+'% MATCH</span>'+
            '</a>';
          }).join('')+'</div>':'')+
        (!clearWinner?
          '<div class="arshe-scent-finder__discovery-note"><strong>Can’t choose just one?</strong><span>Your preferences sit between a few signatures. Explore the Discovery Set side by side.</span><a href="'+esc(discoveryUrl)+'">EXPLORE THE DISCOVERY SET →</a></div>':'');
      show('result');
      window.requestAnimationFrame(scrollContentToTop);
    }

    function lockScroll(){
      if(lockState)return;
      var doc=document.documentElement,body=document.body;
      var scrollY=window.scrollY||window.pageYOffset||0;
      var scrollbar=Math.max(0,window.innerWidth-doc.clientWidth);
      lockState={
        scrollY:scrollY,
        htmlOverflow:doc.style.overflow,
        bodyOverflow:body.style.overflow,
        bodyPosition:body.style.position,
        bodyTop:body.style.top,
        bodyWidth:body.style.width,
        bodyPaddingRight:body.style.paddingRight,
        bodyTouchAction:body.style.touchAction
      };
      doc.style.overflow='hidden';
      body.style.overflow='hidden';
      body.style.position='fixed';
      body.style.top=(-scrollY)+'px';
      body.style.width='100%';
      if(scrollbar)body.style.paddingRight=scrollbar+'px';
      body.style.touchAction='none';
    }

    function unlockScroll(){
      if(!lockState)return;
      var s=lockState,doc=document.documentElement,body=document.body;
      doc.style.overflow=s.htmlOverflow;
      body.style.overflow=s.bodyOverflow;
      body.style.position=s.bodyPosition;
      body.style.top=s.bodyTop;
      body.style.width=s.bodyWidth;
      body.style.paddingRight=s.bodyPaddingRight;
      body.style.touchAction=s.bodyTouchAction;
      window.scrollTo(0,s.scrollY);
      lockState=null;
    }

    function setOrigin(){
      if(!fab)return;
      var r=fab.getBoundingClientRect();
      root.style.setProperty('--sf-origin-x',(r.left+r.width/2)+'px');
      root.style.setProperty('--sf-origin-y',(r.top+r.height/2)+'px');
    }

    function open(){
      lastFocused=document.activeElement;
      setOrigin();
      root.classList.add('is-open');
      fab.setAttribute('aria-expanded','true');
      panel.setAttribute('aria-hidden','false');
      lockScroll();
      scrollContentToTop();
      window.setTimeout(function(){
        var c=root.querySelector('.arshe-scent-finder__close');
        if(c)c.focus();
      },220);
    }

    function close(){
      root.classList.remove('is-open');
      fab.setAttribute('aria-expanded','false');
      panel.setAttribute('aria-hidden','true');
      unlockScroll();
      if(lastFocused && typeof lastFocused.focus==='function'){
        window.setTimeout(function(){lastFocused.focus();},0);
      }
    }

    function reset(){
      current=0;answers=[];renderQuestion();
    }

    function positionFab(){
      var bottom=16;
      var nav=document.querySelector('[data-arshe-mobile-bottom-nav]');
      if(nav){
        var nr=nav.getBoundingClientRect(), ns=getComputedStyle(nav);
        if(ns.position==='fixed' && nr.top<window.innerHeight && ns.display!=='none' && ns.visibility!=='hidden'){
          bottom=Math.max(bottom, window.innerHeight-nr.top+12);
        }
      }

      /* Stack the assistant above every visible commerce bar. This means:
         homepage: nav -> discovery bar -> FAB
         PDP:      nav -> product bar -> FAB
         if both ever coexist, both bars are measured and stacked. */
      var bars=['#arsheStickyBar','#arsheProductSticky'];
      var occupied=bottom;
      bars.forEach(function(sel){
        var el=document.querySelector(sel);
        if(!el)return;
        var r=el.getBoundingClientRect(),cs=getComputedStyle(el);
        if(cs.position==='fixed' && r.bottom>0 && r.top<window.innerHeight && cs.display!=='none' && cs.visibility!=='hidden'){
          occupied=Math.max(occupied, window.innerHeight-r.top+12);
        }
      });
      root.style.setProperty('--arshe-sf-bottom',occupied+'px');
      fab.style.bottom='calc(var(--arshe-sf-bottom) + env(safe-area-inset-bottom))';
      panel.style.bottom='calc(var(--arshe-sf-bottom) + 12px + env(safe-area-inset-bottom))';
    }

    fab.addEventListener('click',open);
    root.querySelectorAll('[data-sf-close]').forEach(function(el){el.addEventListener('click',close);});
    root.querySelector('[data-sf-start]').addEventListener('click',function(){current=0;answers=[];renderQuestion();});
    root.querySelector('[data-sf-back]').addEventListener('click',function(){
      if(current>0){current--;renderQuestion();}
    });
    root.querySelector('[data-sf-restart]').addEventListener('click',reset);

    document.addEventListener('keydown',function(e){
      if(!root.classList.contains('is-open'))return;
      if(e.key==='Escape'){e.preventDefault();close();return;}
      if(e.key!=='Tab')return;
      var f=panel.querySelectorAll('button,a,input,select,textarea,[tabindex]:not([tabindex="-1"])');
      if(!f.length)return;
      var first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    });

    window.addEventListener('resize',function(){positionFab();if(root.classList.contains('is-open'))setOrigin();},{passive:true});
    window.addEventListener('orientationchange',function(){window.setTimeout(positionFab,50);},{passive:true});
    window.addEventListener('scroll',positionFab,{passive:true});

    /* Observe only the fixed controls that determine FAB geometry. The old
       document-body observer did not react reliably to sticky-bar state
       changes and caused unnecessary layout work. */
    var geometryObserver=null;
    var stickyObserver=null;
    function observeFabGeometry(){
      if(geometryObserver){geometryObserver.disconnect();geometryObserver=null;}
      if(stickyObserver){stickyObserver.disconnect();stickyObserver=null;}

      var observed=[];
      var nav=document.querySelector('[data-arshe-mobile-bottom-nav]');
      var sticky=document.querySelector('#arsheStickyBar, #arsheProductSticky');
      if(nav)observed.push(nav);
      if(sticky)observed.push(sticky);

      if(window.ResizeObserver && observed.length){
        geometryObserver=new ResizeObserver(function(){positionFab();});
        observed.forEach(function(el){geometryObserver.observe(el);});
      }

      if(sticky && window.MutationObserver){
        stickyObserver=new MutationObserver(function(){positionFab();});
        stickyObserver.observe(sticky,{attributes:true,attributeFilter:['class','style','aria-hidden']});
      }
    }

    observeFabGeometry();
    positionFab();
    show('intro');
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();